import { render, staticRenderFns } from "./module-selector.vue?vue&type=template&id=16e89164&"
import script from "./module-selector.vue?vue&type=script&lang=js&"
export * from "./module-selector.vue?vue&type=script&lang=js&"
import style0 from "./module-selector.vue?vue&type=style&index=0&id=16e89164&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e89164')) {
      api.createRecord('16e89164', component.options)
    } else {
      api.reload('16e89164', component.options)
    }
    module.hot.accept("./module-selector.vue?vue&type=template&id=16e89164&", function () {
      api.rerender('16e89164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/module-selector.vue"
export default component.exports